import ReactVirtualizedAutoSizer from 'react-virtualized-auto-sizer';
import { Anchor, Box, Button, createStyles, Grid, Group, Select, Tabs, Text, Title } from '@mantine/core';
import { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';
import { useForm } from '@mantine/form';
import { clearNotifications, fetchGuide, fetchGuideCategories, selectGuide, updateGuide } from '../../guideSlice';
import { Crumbline, TabCounterLabel } from '../../../../core/components';
import GuideTabGeneral from './GuideTabGeneral';
import { useEffectOnce } from 'utils/helper';
import { logger } from 'utils/logger';
import GuideTabCategories from './GuideTabCategories';
import { SHELL_TAB_BAR_HEIGHT } from 'utils/constants';

const useStyles = createStyles((theme) => ({
    tab: {
        // marginLeft:`-${theme.spacing.lg}px`,
        // marginRight:`-${theme.spacing.lg}px`
    },
    col: {
        padding: 0,
    },
    tabContent: {
        padding: theme.spacing.xs,
        paddingTop: 0,
    },
}));

const Guide = ({ user, guide, success, error }) => {
    const dispatch = useDispatch();
    const { classes } = useStyles();
    // const navigate = useNavigate();
    // const location = useLocation();
    const params = useParams();
    const [activeTab, setActiveTab] = useState('categories');
    const [isLoading, setIsLoading] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    // get the Guide from the url
    useEffectOnce(() => {
        if (params && params.id) {
            logger.log(params);
            dispatch(fetchGuide(params.id));
        }
    }, [dispatch, fetchGuide]);

    useEffectOnce(() => {
        // fetch the guide categories

        //  we no longer fetch the guide categories
        // if (guide && guide.code.length) {
        //     setIsLoading(true);
        //     dispatch(fetchGuideCategories(guide));
        // } else {
        //     setIsLoading(false);
        // }

        return () => {
            setIsLoading(false);
            dispatch(clearNotifications());
        };
    });

    const form = useForm({
        initialValues: {
            name: '',
            descr: '',
            tags: [],
        },

        validate: {
            name: (value) => (value.length ? null : 'Please enter name'),
            descr: (value) => (value.length ? null : 'Please enter a description'),
        },
    });

    useEffect(() => {
        logger.log('setting form');

        form.setValues({ ...guide });

        if (guide && !guide.guideCategories) {
            dispatch(fetchGuideCategories(guide));
        }

        if (guide) {
            setIsLoading(false);
        }
    }, [guide]);

    const crumbItems = [
        { title: 'Style Guides', route: '/styleguides', search: '' },
        { title: guide?.name, route: `styleguides/${guide?.id}` },
    ];

    const onFormSubmit = (vals) => {
        logger.log('Submitting form');
        const data = {
            ...vals,
            tags: form.values.tags.join(','),
            // team:form.values.team,
            // ts:form.values.ts,
        };
        dispatch(updateGuide(data, user));
    };

    const onTabChange = (val) => {
        var params = Object.fromEntries([...searchParams]);
        params.tab = val;
        setSearchParams(params);
    };
    useEffect(() => {
        // const params = new URLSearchParams(location.search);
        const currentParams = Object.fromEntries([...searchParams]);
        
        if (currentParams.tab) {
            setActiveTab(currentParams.tab);
        }
    }, [searchParams]);

    return (
        <div
            style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
            }}>
            <Group
                className='main-container-header'
                sx={(theme) => ({
                    width: '100%',
                    borderBottom: `1px solid ${theme.colors.gray[3]}`,
                    borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[2],
                    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.white,
                })}>
                <Group px='lg' position='apart' sx={{ width: '100%' }}>
                    <Crumbline items={crumbItems}></Crumbline>
                    {/* <Button>Update Guide</Button> */}
                </Group>
            </Group>

            <Group pt={'lg'} px={'lg'} position='apart'>
                <Group>
                    <Title order={3}>{guide?.name}</Title>
                </Group>
                {/* {style?.styleNumber} -  */}
                {/* <Menu position='bottom-end'>
                    <Menu.Target>
                        <Button variant='outline' rightIcon={<IconChevronDown size={14} />}>
                            Actions
                        </Button>
                    </Menu.Target>

                    <Menu.Dropdown>
                        <Menu.Item onClick={() => onStyleAction({ type: SampleEventType.SAMPLE_DISTRIBUTE })} icon={<IconRocket size={14} />}>
                            Distribute
                        </Menu.Item>
                    </Menu.Dropdown>
                </Menu> */}
            </Group>

            <Grid mb='lg' style={{ margin: 0, height: 'auto', flexGrow: 1 }}>
                <Grid.Col span={12} className={`${classes.col} body-panels`} sx={{ height: '100%' }}>
                    {/* <Title pt={'lg'} px={'lg'} order={3}>
                        {guide?.name}
                    </Title> */}
                    <div style={{ height: '100%' }}>
                        <ReactVirtualizedAutoSizer disableWidth>
                            {({ height, width }) => {
                                return (
                                    <Tabs
                                        value={activeTab}
                                        sx={(theme) => ({
                                            borderRight: `1px solid ${theme.colors.gray[2]}`,
                                            '.mantine-Tabs-tabsList': {
                                                paddingLeft: theme.spacing.lg,
                                                paddingRight: theme.spacing.lg,
                                                paddingTop: 22,
                                            },
                                            borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[2],
                                        })}
                                        onTabChange={(e) => onTabChange(e)}>
                                        <Tabs.List>
                                            <Tabs.Tab value='general'>General</Tabs.Tab>
                                            <Tabs.Tab value='categories'>
                                                <TabCounterLabel label={'Categories'} data={guide} accessor={'guideCategories'} />
                                            </Tabs.Tab>
                                            {/* <Tabs.Tab value="tasks" >Tasks</Tabs.Tab>
                    <Tabs.Tab value="media" >Media</Tabs.Tab>
                    <Tabs.Tab value="samples">Samples</Tabs.Tab>
                    <Tabs.Tab value="talent">Talent</Tabs.Tab> */}
                                            <Tabs.Tab value='activity'>Activity</Tabs.Tab>
                                        </Tabs.List>

                                        <Tabs.Panel value='general' pt='xs'>
                                            <div className={classes.tabContent}>
                                                <GuideTabGeneral form={form} onFormSubmit={onFormSubmit} />
                                            </div>
                                        </Tabs.Panel>
                                        <Tabs.Panel value='categories' pt='xs'>
                                            <div
                                                className={`${classes.tabContent}`}
                                                style={{
                                                    height: height - SHELL_TAB_BAR_HEIGHT,
                                                    overflow: 'auto',
                                                }}>
                                                <GuideTabCategories form={form} onFormSubmit={onFormSubmit} />
                                            </div>
                                        </Tabs.Panel>

                                        <Tabs.Panel value='tasks' pt='xs'>
                                            <div className={classes.tabContent}>{/* <GuideTabTasks form={form} /> */}</div>
                                        </Tabs.Panel>
                                    </Tabs>
                                );
                            }}
                        </ReactVirtualizedAutoSizer>
                    </div>
                </Grid.Col>

                {/* latest info */}
                {/* <Grid.Col span={3} className={classes.col}>
            <div className='right-detail-panel'>
              <Box sx={(theme)=>({
                  borderBottom:`2px solid ${theme.colors.gray[2]}`,  
                  borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[2],         
                })}>
              

                <Group py='xs' px='lg'>
                  <Text size='sm' weight='500'>Status</Text>
                  <Select style={{flexGrow:1}}
                    placeholder="Pick one"
                    data={[
                      { value: 'delayed', label: 'Delayed' },
                      { value: 'onTime', label: 'On Time' },
                      { value: 'archived', label: 'Archived' },
                      { value: 'available', label: 'Available' },
                    ]}
                  />
                </Group>
              </Box>

              <Box px='lg' pt='lg'>

                <Title className='main-content-heading' order={5} mb='lg'>Details</Title>
                
                <Box>
                  <Group my='md'>
                    <Text size='sm' style={{width:'30%'}} weight='500'>Name</Text>
                    <div>
                      <Text size='sm'>John Adams</Text>  
                    </div>                    
                  </Group>

                  <Group my='md'>
                    <Text size='sm' style={{width:'30%'}} weight='500'> Time</Text>
                    <div>
                      <Text size='sm'>30/05/2022 - 9:00 AM</Text>  
                    </div>                    
                  </Group>

                  <Group my='md'>
                    <Text size='sm' style={{width:'30%'}} weight='500'>Location</Text>
                    <div>
                      <Anchor size='sm'>Wellcom Lorimer Street</Anchor>  
                    </div>                    
                  </Group>
                  <Button variant='light' color="brand" fullWidth style={{ marginTop: 14 }}>
                    View Scan Details
                  </Button>

                </Box>

              </Box>

            </div>
          
          </Grid.Col> */}
            </Grid>
        </div>
    );
};

const mapStateToProps = (state, props) => {
    //logger.log(state,props, ' mapstate')
    return {
        user: state.auth.user,
        guide: state.guideReducer.selectedGuide,
        success: state.guideReducer.success,
        error: state.guideReducer.error,
    };
};

const mapDispatch = { selectGuide };

export default connect(mapStateToProps, mapDispatch)(Guide);
